import { render, staticRenderFns } from "./FeedbackNotification.vue?vue&type=template&id=8622d76e&scoped=true"
import script from "./FeedbackNotification.vue?vue&type=script&lang=js"
export * from "./FeedbackNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8622d76e",
  null
  
)

export default component.exports